/**
 * Landing
 * Manages all DOM-side interaction: custom cursor, Canvas2D particle overlay,
 * and scroll reveal animations. Not a Three.js class — imported in script.js.
 */
export default class Landing {
    constructor() {
        this.setCursor()
        this.setParticleCanvas()
        this.setScrollReveal()
    }

    setCursor() {
        this.cursor     = document.getElementById('cursor')
        this.cursorRing = document.getElementById('cursorRing')

        if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) return

        document.addEventListener('mousemove', (e) => {
            this.cursor.style.left     = e.clientX + 'px'
            this.cursor.style.top      = e.clientY + 'px'
            this.cursorRing.style.left = e.clientX + 'px'
            this.cursorRing.style.top  = e.clientY + 'px'
        })
    }

    setParticleCanvas() {
        this.particleCanvas = document.getElementById('particle-canvas')
        this.pc  = this.particleCanvas.getContext('2d')
        this.pmx = window.innerWidth  / 2
        this.pmy = window.innerHeight / 2

        this.particles = Array.from({ length: 60 }, () => ({
            x:     Math.random() * window.innerWidth,
            y:     Math.random() * window.innerHeight,
            r:     Math.random() * 1.5 + 0.3,
            vx:    (Math.random() - 0.5) * 0.3,
            vy:    (Math.random() - 0.5) * 0.2 - 0.05,
            alpha: Math.random() * 0.4 + 0.05,
            color: Math.random() > 0.6 ? '#EDBA97' : Math.random() > 0.5 ? '#A4C0C1' : '#E17426',
        }))

        document.addEventListener('mousemove', (e) => {
            this.pmx = e.clientX
            this.pmy = e.clientY
        })

        document.addEventListener('touchmove', (e) => {
            const t = e.touches[0]
            this.pmx = t.clientX
            this.pmy = t.clientY
        }, { passive: true })

        window.addEventListener('resize', () => this.resizeParticleCanvas())
        this.resizeParticleCanvas()
        this.animateParticles()
    }

    resizeParticleCanvas() {
        this.particleCanvas.width  = window.innerWidth
        this.particleCanvas.height = window.innerHeight
    }

    animateParticles() {
        const { pc, particles, particleCanvas } = this
        pc.clearRect(0, 0, particleCanvas.width, particleCanvas.height)

        particles.forEach(p => {
            const dx   = p.x - this.pmx
            const dy   = p.y - this.pmy
            const dist = Math.sqrt(dx * dx + dy * dy)
            if (dist < 120) {
                p.vx += (dx / dist) * 0.06
                p.vy += (dy / dist) * 0.06
            }
            p.vx *= 0.98
            p.vy *= 0.98
            p.x  += p.vx
            p.y  += p.vy

            if (p.x < 0) p.x = particleCanvas.width
            if (p.x > particleCanvas.width)  p.x = 0
            if (p.y < 0) p.y = particleCanvas.height
            if (p.y > particleCanvas.height) p.y = 0

            pc.beginPath()
            pc.arc(p.x, p.y, p.r, 0, Math.PI * 2)
            pc.fillStyle   = p.color
            pc.globalAlpha = p.alpha
            pc.fill()
        })
        pc.globalAlpha = 1

        requestAnimationFrame(() => this.animateParticles())
    }

    setScrollReveal() {
        const observer = new IntersectionObserver(
            entries => entries.forEach(e => {
                if (e.isIntersecting) {
                    e.target.style.opacity   = '1'
                    e.target.style.transform = 'translateY(0)'
                }
            }),
            { threshold: 0.1 }
        )

        document.querySelectorAll('.step, .preset-card, .plan').forEach(el => {
            el.style.transition = 'opacity 0.7s ease, transform 0.7s ease'
            // Only hide elements that are fully below the viewport — avoids flash of
            // invisible content for elements already in view on load (e.g. How it works steps)
            if (el.getBoundingClientRect().top >= window.innerHeight) {
                el.style.opacity   = '0'
                el.style.transform = 'translateY(30px)'
            }
            observer.observe(el)
        })
    }
}
